export enum FaberPolicyStatus {
    Active = 'Active',
    Cancelled = 'Cancelled',
    Expired = 'Expired',
    Inactive = 'Inactive',
    PaymentFailed = 'PaymentFailed',
    Pending = 'Pending',
    PermSuspended = 'PermSuspended',
    Preactive = 'Preactive',
    StuckPolicy = 'StuckPolicy'
}
